import { Routes } from '../api-routes'
import { BeneficiaryDTO } from '../dtos/beneficiary'
import { ChatMessageDTO, ChatSessionDTO } from '../dtos/message'
import { OrganizationDTO } from '../dtos/organization'
import { TaskDTO } from '../dtos/task'
import { getPath, setP } from './helpers'

export namespace PublicRoutes {
  export namespace feedbacks {
    export namespace createOne {
      export function call(p = setP(['beneficiaryId'])) {
        return getPath(p, {
          suffix: Routes.Feedbacks,
          prefix: Routes.Public,
        })
      }

      export type Request = {
        messageId: string
        feedback: string
      }
      export type Response = boolean
    }
  }
  export namespace beneficiaries {
    export namespace getChatSessionsFromOne {
      export function call(p = setP(['beneficiaryId'])) {
        return getPath(p, {
          suffix: Routes.ChatSessions,
          prefix: Routes.Public,
        })
      }
      export type Response = { chatSessions: ChatSessionDTO[] }
    }

    export namespace getOne {
      export function call(p = setP(['beneficiaryId'])) {
        return getPath(p, { prefix: Routes.Public })
      }
      export type Response = { beneficiary: BeneficiaryDTO }
    }

    export namespace getOrganizationFromOne {
      export function call(p = setP(['beneficiaryId'])) {
        return getPath(p, {
          suffix: Routes.Organizations,
          prefix: Routes.Public,
        })
      }
      export type Response = { organization: OrganizationDTO }
    }

    export namespace patchOne {
      export function call(p = setP(['beneficiaryId'])) {
        return getPath(p, { prefix: Routes.Public })
      }
      export type Request = {
        beneficiaryFields: Pick<BeneficiaryDTO, 'language'>
      }
      export type Response = { beneficiary: BeneficiaryDTO }
    }
  }

  export namespace chatSessions {
    export namespace createOne {
      export function call(p = setP(['beneficiaryId'])) {
        return getPath(p, {
          suffix: Routes.ChatSessions,
          prefix: Routes.Public,
        })
      }
      export type Request = { beneficiaryId: string }
      export type Response = { chatSession: ChatSessionDTO }
    }

    export namespace getMessagesFromOne {
      export function call(p = setP(['chatSessionId'])) {
        return getPath(p, {
          suffix: Routes.ChatMessages,
          prefix: Routes.Public,
        })
      }
      export type Response = { chatMessages: ChatMessageDTO[] }
    }
  }

  export namespace tasks {
    export namespace get {
      export function call(p = setP(['beneficiaryId'])) {
        return getPath(p, { suffix: Routes.Tasks, prefix: Routes.Public })
      }
      export type Response = { tasks: TaskDTO[] }
    }

    export namespace markOneAsDone {
      export function call(p = setP(['beneficiaryId'])) {
        return getPath(p, { suffix: Routes.Tasks, prefix: Routes.Public })
      }
      export type Request = { taskId: string }
      export type Response = { task: TaskDTO }
    }
  }
}
